// /home/szymon/kreator2/frontend/src/components/editor/EditorTopBar.js
import React, { useState, Fragment } from "react"; // Dodano Fragment
import {
  ZoomIn, ZoomOut, ArrowLeft, ArrowRight, ChevronLeft, ChevronRight, Save, Undo, Redo,
  CheckCircle, EyeOff, Star, Lock, Edit, AlignLeft, AlignCenter, AlignRight, Bold, Palette,
  Minus, Plus, Type, Baseline, HelpCircle, PanelLeftClose, LayoutDashboard, Info // Dodano ikonę Info
} from 'lucide-react'; // Import ikon z lucide-react

export default function EditorTopBar({
  onManualSave,
  projectId,
  zoomFactor,
  onZoomChange,
  currentPage,
  pageCount,
  onPrevPage,
  onNextPage,
  onGoBack,
  publicMode,
  onToggleFlag,
  selectedObject,
  onAcceptProject, // Dodano nowy prop do akceptacji projektu
  publicKey,      // Przywrócono brakujący prop
  downloadKey,    // Przywrócono brakujący prop
  backendUrl,     // Przywrócono brakujący prop
  onChangeText = () => {},
  onChangeSvg = () => {},
  undo,
  redo,
  canUndo,
  canRedo,
  isAccepted, // Dodano prop informujący czy projekt jest już zaakceptowany
  tooltipsEnabled, // Nowy prop
  setTooltipsEnabled // Nowy prop
}) {
  const [showSaveConfirmation, setShowSaveConfirmation] = useState(false);
  const [showEmailForSavePopup, setShowEmailForSavePopup] = useState(false);
  const [saveEmail, setSaveEmail] = useState("");
  const [savePopupError, setSavePopupError] = useState("");
  const [saveSending, setSaveSending] = useState(false);
  const [showAcceptConfirmPopup, setShowAcceptConfirmPopup] = useState(false); // Stan dla popupu potwierdzenia akceptacji

  const isText = selectedObject && selectedObject._type === "text";
  const isSvg = selectedObject && selectedObject._type === "svg";

  let localColorArr = [0, 0, 0];

  if (isText) {
    localColorArr = selectedObject.color || [0, 0, 0];
  } else if (isSvg) {
    localColorArr = selectedObject.color || [0, 0, 0];
  }

  const handleZoomIn = () => {
    const newVal = zoomFactor + 0.1;
    onZoomChange(newVal > 10 ? 10 : newVal);
  };

  const handleZoomOut = () => {
    const newVal = zoomFactor - 0.1;
    onZoomChange(newVal < 0.1 ? 0.1 : newVal);
  };

  const handleClickSave = async () => {
    if (!publicMode) {
      onManualSave(false);
      setShowSaveConfirmation(true);
      return;
    }
    try {
      const cleanedPublicKey = String(publicKey || '').replace(/[^a-zA-Z0-9]/g, '');
      const orderUrl = `${backendUrl}/client/orders/${cleanedPublicKey}`;
      console.log(`[EditorTopBar] handleClickSave: Fetching order with cleaned key: ${orderUrl}`);
      const orderRes = await fetch(orderUrl, {
        credentials: "include"
      });
      if (!orderRes.ok) {
        throw new Error("Błąd pobierania zamówienia w publicMode.");
      }
      const orderData = await orderRes.json();
      const currentEmail = orderData.customOrderId || "";
      if (currentEmail.trim()) {
        onManualSave(false);
        setShowSaveConfirmation(true);
      } else {
        setShowEmailForSavePopup(true);
        setSaveEmail("");
      }
    } catch (err) {
      console.error("Błąd pobierania zamówienia:", err);
    }
  };

  const handleConfirmSavePopup = async () => {
      setSavePopupError("");
      if (!saveEmail || !saveEmail.includes("@")) {
        setSavePopupError("Niepoprawny adres e-mail!");
        return;
      }
      setSaveSending(true);
      try {
        const cleanedPublicKey = String(publicKey || '').replace(/[^a-zA-Z0-9]/g, '');
        const patchUrl = `${backendUrl}/client/orders/${cleanedPublicKey}/email`;
        const body = { email: saveEmail, downloadKey };
        console.log(`[EditorTopBar] handleConfirmSavePopup: Patching email: ${patchUrl}`);
        const patchRes = await fetch(patchUrl, {
        method: "PATCH",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });
      if (!patchRes.ok) {
        throw new Error("Błąd zapisu e-maila w zamówieniu (patch).");
      }
      onManualSave(false);
      setShowEmailForSavePopup(false);
      setShowSaveConfirmation(true);
    } catch (ex) {
      setSavePopupError(ex.message);
    } finally {
      setSaveSending(false);
    }
  };

  // Zmodyfikowana funkcja - najpierw pokazuje popup
  const handleAcceptProject = () => {
    setShowAcceptConfirmPopup(true);
  };

  // Funkcja wywoływana po potwierdzeniu w popupie
  const handleConfirmAcceptProject = () => {
    setShowAcceptConfirmPopup(false); // Zamknij popup
    if (onAcceptProject) {
      onAcceptProject(); // Wywołaj oryginalną funkcję akceptacji
    } else {
      console.warn("onAcceptProject prop not provided to EditorTopBar");
    }
  };


  const topBarStyle = {
    height: "64px",
    backgroundColor: "#ffffff",
    color: "#1a202c",
    borderBottom: "1px solid #e2e8f0",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 24px",
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)"
  };

  const containerBaseStyle = {
    display: "flex",
    alignItems: "center",
    gap: "16px"
  };

  const leftContainerStyle = { ...containerBaseStyle };
  const centerContainerStyle = { ...containerBaseStyle, flexGrow: 1, justifyContent: 'center' };
  const rightContainerStyle = { ...containerBaseStyle };

  const buttonBaseStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "8px 16px",
    border: "1px solid transparent",
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: 500,
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    backgroundColor: "transparent",
    color: "#4a5568",
  };

  const iconButtonStyle = {
    ...buttonBaseStyle,
    padding: "8px",
    color: "#718096",
    backgroundColor: 'transparent',
    border: 'none',
  };

  const primaryButtonStyle = {
    ...buttonBaseStyle,
    backgroundColor: "#4299e1",
    color: "#ffffff",
    borderColor: "#4299e1",
  };

   const secondaryButtonStyle = {
    ...buttonBaseStyle,
    backgroundColor: "#ffffff",
    color: "#4a5568",
    borderColor: "#e2e8f0",
  };

  const successButtonStyle = {
    ...buttonBaseStyle,
    backgroundColor: "#48bb78",
    color: "#ffffff",
    borderColor: "#48bb78",
  };

  const disabledButtonStyle = {
    opacity: 0.6,
    cursor: "not-allowed",
  };

  const flags = selectedObject?.flags || {
    noPrint: false,
    gold: false,
    locked: false,
    personalize: false
  };

  function rgbToHex(r, g, b) {
    const clampVal = (v) => Math.max(0, Math.min(255, v));
    const toHex = (val) => {
      const x = clampVal(val).toString(16);
      return x.length < 2 ? "0" + x : x;
    };
    return "#" + toHex(r) + toHex(g) + toHex(b);
  }
  const [r, g, b] = localColorArr;
  const colorHex = rgbToHex(r, g, b);

  const handleColorPickerChange = (e) => {
    const val = e.target.value.replace("#", "");
    const rr = parseInt(val.slice(0, 2), 16);
    const gg = parseInt(val.slice(2, 4), 16);
    const bb = parseInt(val.slice(4, 6), 16);
    if (isText && selectedObject?.id) {
      onChangeText({ id: selectedObject.id, color: [rr, gg, bb] });
    } else if (isSvg && selectedObject?.id) {
      onChangeSvg({ id: selectedObject.id, color: [rr, gg, bb] });
    }
  };

  const handleFontSizeChange = (e) => {
    const newVal = parseInt(e.target.value);
    if (selectedObject?.id) {
      onChangeText({ id: selectedObject.id, fontSize: newVal });
    }
  };

  const handleLineHeightDelta = (delta) => {
    if (!selectedObject?.id) return;
    const oldVal = selectedObject.lineHeight || 1.0;
    const newVal = Math.round((oldVal + delta) * 100) / 100;
    if (newVal < 0.1) return;
    onChangeText({ id: selectedObject.id, lineHeight: newVal });
  };

  const handleLetterSpacingDelta = (delta) => {
    if (!selectedObject?.id) return;
    const oldVal = selectedObject.letterSpacing || 0;
    const newVal = Math.round((oldVal + delta) * 100) / 100;
    onChangeText({ id: selectedObject.id, letterSpacing: newVal });
  };

  const handleAlignment = (align) => {
    if (!selectedObject?.id) return;
    onChangeText({ id: selectedObject.id, alignment: align });
  };

  const handleToggleBoldOutline = () => {
    if (!selectedObject?.id) return;
    const currentStrokeWidth = selectedObject.strokeWidth || 0;
    const newStrokeWidth = currentStrokeWidth > 0 ? 0 : 0.7;
    const color = selectedObject.color || [0, 0, 0];
    onChangeText({
      id: selectedObject.id,
      strokeWidth: newStrokeWidth,
      stroke: color
    });
  };

  return (
    <>
      {/* Style dla przełącznika */}
      <style>{`
        .switch {
          position: relative;
          display: inline-block;
          width: 40px;
          height: 20px;
          margin-left: 8px; /* Dodano margines dla odstępu */
        }
        .switch input {
          opacity: 0;
          width: 0;
          height: 0;
        }
        .slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #ccc;
          transition: .4s;
          border-radius: 20px;
        }
        .slider:before {
          position: absolute;
          content: "";
          height: 16px;
          width: 16px;
          left: 2px;
          bottom: 2px;
          background-color: white;
          transition: .4s;
          border-radius: 50%;
        }
        input:checked + .slider {
          background-color: #4299e1; /* Niebieski */
        }
        input:checked + .slider:before {
          transform: translateX(20px);
        }
      `}</style>
      <div style={topBarStyle}>
        <div style={leftContainerStyle}>
          {/* Usunięto przycisk "Wróć" */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <button
              onClick={handleZoomOut}
              style={iconButtonStyle}
              title="Pomniejsz (Ctrl + -)"
              data-tooltip-id={tooltipsEnabled ? "editor-tooltip" : undefined}
              data-tooltip-content={tooltipsEnabled ? "Zmniejsz powiększenie widoku projektu." : undefined}
            >
              <ZoomOut size={24} />
            </button>
            <span style={{ fontSize: '14px', color: '#718096', minWidth: '40px', textAlign: 'center' }}>
              {Math.round(zoomFactor * 100)}%
            </span>
            <button
              onClick={handleZoomIn}
              style={iconButtonStyle}
              title="Powiększ (Ctrl + +)"
              data-tooltip-id={tooltipsEnabled ? "editor-tooltip" : undefined}
              data-tooltip-content={tooltipsEnabled ? "Zwiększ powiększenie widoku projektu." : undefined}
            >
              <ZoomIn size={24} />
            </button>
            {/* Usunięto ikonę HelpCircle */}
          </div>
        </div>

        <div style={centerContainerStyle}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <button
              onClick={onPrevPage}
              disabled={currentPage <= 0}
              style={{
                ...iconButtonStyle,
                ...(currentPage <= 0 ? disabledButtonStyle : {})
              }}
              title="Poprzednia strona"
              data-tooltip-id={tooltipsEnabled ? "editor-tooltip" : undefined}
              data-tooltip-content={tooltipsEnabled ? "Przejdź do poprzedniej strony projektu." : undefined}
            >
              <ChevronLeft size={40} /> {/* Zwiększono rozmiar ikony */}
            </button>

            <span style={{ fontSize: 16, color: "#4a5568", minWidth: '100px', textAlign: 'center' }}>
              Strona {currentPage + 1} / {pageCount}
            </span>

            <button
              onClick={onNextPage}
              disabled={currentPage >= pageCount - 1}
               style={{
                ...iconButtonStyle,
                ...(currentPage >= pageCount - 1 ? disabledButtonStyle : {})
              }}
              title="Następna strona"
              data-tooltip-id={tooltipsEnabled ? "editor-tooltip" : undefined}
              data-tooltip-content={tooltipsEnabled ? "Przejdź do następnej strony projektu." : undefined}
            >
              <ChevronRight size={40} /> {/* Zwiększono rozmiar ikony */}
            </button>
            {/* Usunięto ikonę HelpCircle */}
          </div>

          {!publicMode && selectedObject && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginLeft: 40 }}>
              <button
                 style={{...iconButtonStyle, color: flags.noPrint ? '#e53e3e' : '#718096'}}
                 title="Nie Drukuj"
                 onClick={() => onToggleFlag("noPrint")}
                 data-tooltip-id={tooltipsEnabled ? "editor-tooltip" : undefined}
                 data-tooltip-content={tooltipsEnabled ? "Oznacz element jako niewidoczny na finalnym wydruku." : undefined}
              >
                 <EyeOff size={24} />
              </button>
               <button
                 style={{...iconButtonStyle, color: flags.gold ? '#d69e2e' : '#718096'}}
                 title="Złocenie"
                 onClick={() => onToggleFlag("gold")}
                 data-tooltip-id={tooltipsEnabled ? "editor-tooltip" : undefined}
                 data-tooltip-content={tooltipsEnabled ? "Oznacz element do specjalnego uszlachetnienia (np. złocenia)." : undefined}
              >
                 <Star size={24} />
              </button>
               <button
                 style={{...iconButtonStyle, color: flags.locked ? '#4299e1' : '#718096'}}
                 title="Zablokuj edycję"
                 onClick={() => onToggleFlag("locked")}
                 data-tooltip-id={tooltipsEnabled ? "editor-tooltip" : undefined}
                 data-tooltip-content={tooltipsEnabled ? "Zablokuj możliwość edycji tego elementu przez klienta." : undefined}
              >
                 <Lock size={24} />
              </button>
               <button
                 style={{...iconButtonStyle, color: flags.personalize ? '#48bb78' : '#718096'}}
                 title="Włącz personalizację"
                 onClick={() => onToggleFlag("personalize")}
                 data-tooltip-id={tooltipsEnabled ? "editor-tooltip" : undefined}
                 data-tooltip-content={tooltipsEnabled ? "Oznacz pole tekstowe jako miejsce do personalizacji (np. listy gości)." : undefined}
              >
                 <Edit size={24} />
              </button>
              {/* Usunięto ikonę HelpCircle */}
            </div>
          )}

          {isText && (
            <div style={{ display: "flex", alignItems: "center", gap: "16px", marginLeft: 40 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }} data-tooltip-id={tooltipsEnabled ? "editor-tooltip" : undefined} data-tooltip-content={tooltipsEnabled ? "Zmień rozmiar zaznaczonego tekstu." : undefined}>
                <Type size={20} color="#555" />
                <select
                  value={selectedObject?.fontSize || 14}
                  onChange={handleFontSizeChange}
                  aria-label="Rozmiar czcionki"
                  style={{
                    fontSize: 14,
                    padding: "4px 8px",
                    border: "1px solid #d1d5db",
                    borderRadius: "4px",
                    backgroundColor: "#fff",
                    cursor: 'pointer'
                  }}
                >
                  {[8, 9, 10, 11, 12, 14, 16, 18, 20, 24, 28, 32, 36, 48, 60, 72].map((sizeVal) => (
                    <option key={sizeVal} value={sizeVal}>
                      {sizeVal} pt
                    </option>
                  ))}
                  {![8, 9, 10, 11, 12, 14, 16, 18, 20, 24, 28, 32, 36, 48, 60, 72].includes(selectedObject?.fontSize) && selectedObject?.fontSize && (
                    <option value={selectedObject.fontSize}>{selectedObject.fontSize} pt</option>
                  )}
                </select>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "4px",
                  borderRadius: "4px",
                  backgroundColor: "#f9fafb",
                  gap: "4px",
                  border: "1px solid #d1d5db"
                }}
                 data-tooltip-id={tooltipsEnabled ? "editor-tooltip" : undefined} data-tooltip-content={tooltipsEnabled ? "Zmień odstęp między literami (kerning)." : undefined}
              >
                <button
                  onClick={() => handleLetterSpacingDelta(-0.1)}
                  style={{ ...iconButtonStyle, padding: '2px' }}
                  aria-label="Zmniejsz odstęp między literami"
                >
                  <Minus size={18} />
                </button>
                <span
                  style={{
                    fontSize: 14,
                    color: "#333",
                    minWidth: "36px",
                    textAlign: "center"
                  }}
                >
                  {selectedObject?.letterSpacing?.toFixed(1) || "0.0"}
                </span>
                <button
                  onClick={() => handleLetterSpacingDelta(+0.1)}
                  style={{ ...iconButtonStyle, padding: '2px' }}
                  aria-label="Zwiększ odstęp między literami"
                >
                  <Plus size={18} />
                </button>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "4px",
                  borderRadius: "4px",
                  backgroundColor: "#f9fafb",
                  gap: "4px",
                  border: "1px solid #d1d5db"
                }}
                 data-tooltip-id={tooltipsEnabled ? "editor-tooltip" : undefined} data-tooltip-content={tooltipsEnabled ? "Zmień odstęp między liniami tekstu (interlinia)." : undefined}
              >
                <Baseline size={20} color="#555" />
                <button
                  onClick={() => handleLineHeightDelta(-0.1)}
                  style={{ ...iconButtonStyle, padding: '2px' }}
                  aria-label="Zmniejsz interlinię"
                >
                  <Minus size={18} />
                </button>
                <span
                  style={{
                    fontSize: 14,
                    color: "#333",
                    minWidth: "36px",
                    textAlign: "center"
                  }}
                >
                  {selectedObject?.lineHeight?.toFixed(1) || "1.0"}
                </span>
                <button
                  onClick={() => handleLineHeightDelta(+0.1)}
                  style={{ ...iconButtonStyle, padding: '2px' }}
                  aria-label="Zwiększ interlinię"
                >
                  <Plus size={18} />
                </button>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: "4px", backgroundColor: "#f9fafb", border: "1px solid #d1d5db", borderRadius: '4px', padding: '2px' }} data-tooltip-id={tooltipsEnabled ? "editor-tooltip" : undefined} data-tooltip-content={tooltipsEnabled ? "Zmień wyrównanie tekstu." : undefined}>
                <button
                  onClick={() => handleAlignment("left")}
                  style={{
                    ...iconButtonStyle,
                    padding: '6px',
                    backgroundColor: selectedObject?.alignment === "left" ? "#e5e7eb" : "transparent",
                  }}
                  aria-label="Wyrównaj do lewej"
                >
                  <AlignLeft size={20} color="#333" />
                </button>
                <button
                  onClick={() => handleAlignment("center")}
                  style={{
                     ...iconButtonStyle,
                    padding: '6px',
                    backgroundColor: selectedObject?.alignment === "center" ? "#e5e7eb" : "transparent",
                  }}
                  aria-label="Wyrównaj do środka"
                >
                  <AlignCenter size={20} color="#333" />
                </button>
                <button
                  onClick={() => handleAlignment("right")}
                  style={{
                     ...iconButtonStyle,
                    padding: '6px',
                    backgroundColor: selectedObject?.alignment === "right" ? "#e5e7eb" : "transparent",
                  }}
                  aria-label="Wyrównaj do prawej"
                >
                  <AlignRight size={20} color="#333" />
                </button>
                <button
                  onClick={handleToggleBoldOutline}
                  style={{
                    ...iconButtonStyle,
                    padding: '6px',
                    backgroundColor: (selectedObject?.strokeWidth || 0) > 0 ? "#e5e7eb" : "transparent",
                  }}
                  aria-label="Pogrubienie (obrys)"
                   data-tooltip-id={tooltipsEnabled ? "editor-tooltip" : undefined} data-tooltip-content={tooltipsEnabled ? "Dodaj lub usuń pogrubienie (realizowane przez obrys w kolorze tekstu)." : undefined}
                >
                  <Bold size={20} color="#333" />
                </button>
              </div>

              <div
                style={{ display: "flex", alignItems: "center", gap: "4px", marginLeft: 10 }}
                data-tooltip-id={tooltipsEnabled ? "editor-tooltip" : undefined} data-tooltip-content={tooltipsEnabled ? "Zmień kolor zaznaczonego tekstu lub obiektu SVG." : undefined}
              >
                <Palette size={20} color="#555" />
                <input
                  type="color"
                  value={colorHex}
                  onChange={handleColorPickerChange}
                  aria-label="Wybierz kolor"
                  style={{
                    width: 32,
                    height: 32,
                    border: "1px solid #d1d5db",
                    borderRadius: '4px',
                    cursor: "pointer",
                    padding: '2px',
                    backgroundColor: 'transparent'
                  }}
                />
              </div>
              {/* Usunięto ikonę HelpCircle */}
            </div>
          )}

          {isSvg && (
            <div style={{ display: "flex", alignItems: "center", gap: "16px", marginLeft: 40 }}>
               <div
                style={{ display: "flex", alignItems: "center", gap: "4px" }}
                data-tooltip-id={tooltipsEnabled ? "editor-tooltip" : undefined} data-tooltip-content={tooltipsEnabled ? "Zmień kolor zaznaczonego obiektu SVG." : undefined}
              >
                <Palette size={20} color="#555" />
                <input
                  type="color"
                  value={colorHex}
                  onChange={handleColorPickerChange}
                  aria-label="Wybierz kolor SVG"
                  style={{
                    width: 32,
                    height: 32,
                    border: "1px solid #d1d5db",
                    borderRadius: '4px',
                    cursor: "pointer",
                    padding: '2px',
                    backgroundColor: 'transparent'
                  }}
                />
              </div>
               {/* Usunięto ikonę HelpCircle */}
            </div>
          )}
        </div>

        <div style={rightContainerStyle}>
           {/* Przełącznik tooltipów */}
           <div style={{ display: 'flex', alignItems: 'center' }} title={tooltipsEnabled ? "Wyłącz podpowiedzi" : "Włącz podpowiedzi"}>
             <span style={{ fontSize: '13px', color: '#4a5568', marginRight: '5px' }}>Podpowiedzi:</span>
             <label className="switch">
               <input
                 type="checkbox"
                 checked={tooltipsEnabled}
                 onChange={() => setTooltipsEnabled(!tooltipsEnabled)}
               />
               <span className="slider"></span>
             </label>
           </div>

           <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
             <button
               onClick={undo}
               disabled={!canUndo}
               style={{
                 ...secondaryButtonStyle,
                 padding: '8px 12px',
                 ...(!canUndo ? disabledButtonStyle : {})
               }}
               title="Cofnij (Ctrl+Z)"
               data-tooltip-id={tooltipsEnabled ? "editor-tooltip" : undefined} data-tooltip-content={tooltipsEnabled ? "Cofnij ostatnią wykonaną akcję." : undefined}
             >
               <Undo size={20} style={{ marginRight: '4px' }} />
               Cofnij
             </button>
             {/* Usunięto ikonę HelpCircle */}
           </div>

           <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
             <button
               onClick={handleClickSave}
               style={secondaryButtonStyle}
               title="Zapisz bieżący stan projektu"
               data-tooltip-id={tooltipsEnabled ? "editor-tooltip" : undefined} data-tooltip-content={tooltipsEnabled ? "Zapisz wszystkie wprowadzone zmiany w projekcie. W trybie publicznym może wymagać podania adresu e-mail." : undefined}
               onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e2e8f0'}
               onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#ffffff'}
             >
               <Save size={20} style={{ marginRight: '4px' }} />
               Zapisz projekt
             </button>
             {/* Usunięto ikonę HelpCircle */}
           </div>

           {publicMode && (
             <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
               <button
                 onClick={handleAcceptProject}
                 disabled={isAccepted}
                 style={{
                   ...successButtonStyle,
                   ...(isAccepted ? disabledButtonStyle : {})
                 }}
                 title={isAccepted ? "Projekt został już zaakceptowany" : "Zaakceptuj projekt i prześlij do realizacji"}
                 data-tooltip-id={tooltipsEnabled ? "editor-tooltip" : undefined} data-tooltip-content={tooltipsEnabled ? (isAccepted ? "Projekt został już zaakceptowany i wysłany." : "Kliknij, aby ostatecznie zaakceptować projekt. Po akceptacji edycja nie będzie możliwa.") : undefined}
                 onMouseOver={(e) => !isAccepted && (e.currentTarget.style.backgroundColor = '#38a169')}
                 onMouseOut={(e) => !isAccepted && (e.currentTarget.style.backgroundColor = '#48bb78')}
               >
                 <CheckCircle size={20} style={{ marginRight: '4px' }} />
                 {isAccepted ? "Zaakceptowano" : "Zaakceptuj projekt"}
               </button>
               {/* Usunięto ikonę HelpCircle */}
             </div>
           )}

           {publicMode && onGoBack && (
             <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
               <button
                 onClick={onGoBack}
                 style={primaryButtonStyle}
                 title="Wróć do panelu zamówienia"
                 data-tooltip-id={tooltipsEnabled ? "editor-tooltip" : undefined} data-tooltip-content={tooltipsEnabled ? "Aby dokończyć składanie zamówienia, przejdź do panelu zamówienia." : undefined}
                 onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#2b6cb0'}
                 onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#4299e1'}
               >
                 <LayoutDashboard size={20} style={{ marginRight: '4px' }} />
                 Panel zamówienia
               </button>
               {/* Usunięto ikonę HelpCircle */}
             </div>
           )}
         </div>
       </div>

      {showSaveConfirmation && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: 20,
              borderRadius: 6,
              boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
              minWidth: 300,
              textAlign: "center"
            }}
          >
            <h2 style={{ marginBottom: 20 }}>Projekt zapisany!</h2>
            <button
              onClick={() => setShowSaveConfirmation(false)}
              style={{
                border: "1px solid #777",
                background: "#fff",
                borderRadius: 4,
                cursor: "pointer",
                padding: "8px 16px",
                fontSize: 16
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {showEmailForSavePopup && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: 20,
              borderRadius: 8,
              width: "400px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
              display: "flex",
              flexDirection: "column"
            }}
          >
            <h2 style={{ marginBottom: 16 }}>Podaj swój adres mailowy</h2>
            <p style={{ marginBottom: 8 }}>
              Wyślemy Ci maila z linkiem do projektu.
            </p>

            {savePopupError && (
              <div style={{ color: "red", marginBottom: 10 }}>{savePopupError}</div>
            )}

            <input
              type="email"
              value={saveEmail}
              onChange={(e) => setSaveEmail(e.target.value)}
              style={{
                padding: 8,
                marginBottom: 12,
                border: "1px solid #ccc",
                borderRadius: 4
              }}
              placeholder="np. janina@example.com"
            />

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
              <button
                onClick={() => setShowEmailForSavePopup(false)}
                style={{
                  border: "1px solid #777",
                  background: "#fff",
                  borderRadius: 4,
                  cursor: "pointer",
                  padding: "8px 16px",
                  fontSize: 14
                }}
                disabled={saveSending}
              >
                Anuluj
              </button>

              <button
                onClick={handleConfirmSavePopup}
                style={{
                  border: "1px solid #777",
                  background: "#5cb85c",
                  color: "#fff",
                  borderRadius: 4,
                  cursor: "pointer",
                  padding: "8px 16px",
                  fontSize: 14
                }}
                disabled={saveSending}
              >
                {saveSending ? "Zapisywanie..." : "Zapisz"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Popup potwierdzenia akceptacji projektu */}
      {showAcceptConfirmPopup && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000 // Wyższy zIndex niż inne popupy
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "25px",
              borderRadius: 8,
              width: "450px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
              display: "flex",
              flexDirection: "column",
              textAlign: "center"
            }}
          >
            <h2 style={{ marginBottom: 15, fontSize: '1.3em', color: '#333' }}>Potwierdzenie akceptacji</h2>
            <p style={{ marginBottom: 25, fontSize: '1em', color: '#555', lineHeight: '1.5' }}>
              Czy na pewno chcesz zaakceptować projekt? Po akceptacji zmiany w projekcie będzie mógł nanieść jedynie nasz grafik.
            </p>

            <div style={{ display: "flex", justifyContent: "center", gap: 15 }}>
              <button
                onClick={() => setShowAcceptConfirmPopup(false)}
                style={{
                  ...secondaryButtonStyle, // Użyj stylu przycisku drugorzędnego
                  padding: "10px 20px",
                  fontSize: 15
                }}
              >
                Anuluj
              </button>

              <button
                onClick={handleConfirmAcceptProject}
                style={{
                  ...successButtonStyle, // Użyj stylu przycisku sukcesu
                   padding: "10px 20px",
                   fontSize: 15
                }}
              >
                Tak, akceptuję
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
